
import Footer from "@/components/Footer";
import Header from "@/components/HeaderUpdated";
import { Button } from "@/components/ui/button";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <TooltipProvider>
      <div className="min-h-screen flex flex-col bg-brand-darker">
        <Header />
        <main className="flex-grow flex items-center justify-center py-20">
          <div className="container mx-auto px-4 text-center">
            <div className="animate-fadeIn">
              <h1 className="text-8xl font-black text-brand-red mb-6">404</h1>
              <p className="text-xl text-white mb-8">Oops! Página não encontrada</p>
              <Link to="/">
                <Button className="btn-primary">Voltar para Home</Button>
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </TooltipProvider>
  );
};

export default NotFound;
